module.exports = __webpack_public_path__ + "static/img/pay-de-btn.1bdb443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-de-btn.png
// module id = jwg4
// module chunks = 1